import { jobSchema, type RotateRequestInput, type Job } from '@xphoto/shared';
import { ApiError } from '../gallery/api';
import { apiFetch } from '../lib/http';

/**
 * Client typé de la ROTATION de la sélection (outil « Pivoter »). La réponse est RE-PARSÉE
 * via son schéma partagé (`jobSchema`) — « never trust the client », y compris ses propres
 * réponses.
 */

async function readJson(res: Response): Promise<unknown> {
  if (!res.ok) {
    let code = 'UNKNOWN';
    try {
      const body = (await res.json()) as { error?: { code?: string } };
      if (typeof body?.error?.code === 'string') code = body.error.code;
    } catch {
      // Corps non-JSON : on garde le code générique.
    }
    throw new ApiError(res.status, code);
  }
  return res.json();
}

/**
 * `POST /api/libraries/:id/rotate` — enfile un job de rotation par le tag EXIF Orientation
 * (droite 90° / gauche 90° / 180° ; vidéos ignorées). Le corps cible une sélection
 * d'`assetIds` + une `direction`. Renvoie le job créé (201). Une écriture désactivée renvoie
 * 409 `WRITE_DISABLED` → propagée en `ApiError` (statut 409, code WRITE_DISABLED).
 */
export async function enqueueRotate(libraryId: string, body: RotateRequestInput): Promise<Job> {
  const res = await apiFetch(`/api/libraries/${libraryId}/rotate`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  return jobSchema.parse(await readJson(res));
}
